import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronUp } from "lucide-react";
import { HeroVideo } from "../components/site/HeroVideo";

export default function Landing() {
  const [started, setStarted] = useState(false);
  const startY = useRef(null);
  const nav = useNavigate();

  // Fallback: show the button even if autoplay is blocked
  useEffect(() => {
    const t = setTimeout(() => setStarted(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const onTouchStart = (e) => { startY.current = e.touches[0].clientY; };
  const onTouchEnd = (e) => {
    if (startY.current === null) return;
    const dy = e.changedTouches[0].clientY - startY.current;
    startY.current = null;
    if (dy < -60) nav("/home");
  };

  return (
    <div className="fixed inset-0 h-[100dvh] w-screen bg-black overflow-hidden touch-pan-x" data-testid="landing-page"
      onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <HeroVideo src="/00shots-hero.mp4" poster="/00shots-hero-poster.jpg" fill onPlaying={() => setStarted(true)} />
      <div className={`landing-more absolute left-1/2 -translate-x-1/2 z-10 bottom-[max(1.5rem,env(safe-area-inset-bottom))] sm:bottom-8 flex flex-col items-center gap-1 ${started ? "is-visible" : "pointer-events-none"}`}>
        <span className="sm:hidden flex flex-col items-center text-[#00d436] font-gothic text-2xl leading-none animate-bounce drop-shadow-[0_0_10px_rgba(0,212,54,0.6)]" data-testid="landing-swipe-hint">
          <ChevronUp className="w-6 h-6" strokeWidth={2.5} /> swipe up
        </span>
        <Link to="/home" data-testid="landing-for-more-link" aria-hidden={!started}
          className="hidden sm:inline-block font-gothic text-xl sm:text-2xl leading-none text-lime px-5 pt-1.5 pb-2 rounded-full border border-[#00d436]/60 bg-black/50 backdrop-blur hover:bg-[#00d436] hover:text-black transition-colors">
          more
        </Link>
      </div>
    </div>
  );
}
